export default __webpack_public_path__ + "static/Beer_Liquid-0f29306273a0ffd6305adad9a18483ed.png";